import React, { useState, useEffect } from "react";
import { Grid, Paper, Chip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PublicIcon from "@material-ui/icons/Public";
import CardsIndividual from "./componentes/CardsIndividual";
import CardsMasiva from "../Dashboard/CardsMasiva";
import { useLocation } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import { IconClipboardList } from "@tabler/icons";
import { obtenerPeriodoOperacion } from "../../actions/usuarioAction";
import { obtenerCentroCostoModal } from "../../actions/centroCostoModal"
import {
  IconFileCheck,
  IconBuildingFactory2,
  IconCalendarTime,
  IconAlertCircle,
} from "@tabler/icons";
import { padding } from "@mui/system";
import EncabezadoTipoCarga from "./EncabezadoTipoCarga";

const useStyles = makeStyles(() => ({
  root: {
    width: '80% !important',
    marginLeft: '6% !important'
  },
  contenedorHeadCard: {
    backgroundColor: "#FFFFFF",
    marginTop: "0px",
    margin: "0 auto",
    justifyContent: "center",
    borderRadius: "20px",
    overflow: "hidden",
    width: "93% !important"
  },
  containerbox: {
    justifyContent: "space-evenly",
  },
  encabezado: {
    display: "flex",
    justifyContent: "center",
    marginLeft: "110px",
  },
  headCard: {
    backgroundColor: "black",
    height: "40px",
    color: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: ".9rem",
    borderRadius: "20px 20px 0 0",
  },
  tipoDeContrato: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    boxShadow: "none !important",
    flexWrap: "wrap",
    backgroundColor: "#FFFFFF",
    height: "70px",
    alignContent: "center"
  },
  gridstyle: {
    display: "flex",
    justifyContent: "center",
  },
  iconoMasTexto: {
    display: "flex",
    flexDirection: "row",
  },
  numContrato: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: "10px !important",
  },
  numContratoIcono: {
    padding: "0px !important",
    margin: "0px !important",
  },
  numContratoTextos: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
  },
  textoUno: {
    letterSpacing: "0px !important",
    padding: "0px !important",
    margin: "0px !important",
    fontWeight: "bold",
    color: "#2B5368",
    fontSize: ".8rem",
  },
  textoDos: {
    letterSpacing: "0px !important",
    padding: "0px !important",
    margin: "0px !important",
    color: "#F77F00",
    fontSize: ".9rem",
    fontWeight: "bolder",
  },
  contenedortipo: {
    height: "50vh",
  },

}));




function CajaHoras(props) {

  // const [res, updateRes] = useState([]);
  //const {state} = useLocation();
  let location = useLocation();
  let storageContratoElegido = JSON.parse(
    localStorage.getItem("contratoElegido")
  );
  const state =
    localStorage.getItem("contratoElegido") == null
      ? location.state
      : storageContratoElegido;
  const contrato =
    localStorage.getItem("contratoElegido") == null ? state.contrato : state;

  let idContratoSeleccionado = JSON.parse(localStorage.getItem("contratoElegido"))

  useEffect(() => {
    let idOperacion = storageContratoElegido.idOperacion;
    let anio = new Date().getFullYear();

    obtenerPeriodoOperacion(idOperacion,anio).then((resp) => {
      localStorage.setItem("periodo",JSON.stringify(resp));
    });

    obtenerCentroCostoModal(idContratoSeleccionado.id)
    .then((resp) => {
      localStorage.setItem("centroCostoModal",JSON.stringify(resp));
    })
    .catch((err) => {
      console.log("Error almacenamiento en localStorage ceco: ", err);
    })

  }, []);


  const classes = useStyles();
  return (
    
    <div className={classes.root} >   
      <Chip
        icon={<HomeIcon />}
        style={{
          color: "black",
          fontSize: "13px",
          top: "40px",
        }}
        label="Home/Contratos/Tipo de Carga">
      </Chip>

        <Grid>          
              <EncabezadoTipoCarga />
        </Grid>
        
        <section style={{marginBottom: "35px"}}>
            <Paper className={classes.contenedorHeadCard}>
              <Paper className={classes.headCard}>Datos del Contrato</Paper>

              <Paper className={classes.tipoDeContrato}>
                <div className={classes.numContrato}>
                  <div className={classes.numContratoIcono}>
                    <IconFileCheck
                      size={35}
                      color="black"
                      stroke={1.2}
                      style={{ marginRight:5 }}  
                    />
                  </div>
                  <div className={classes.numContratoTextos}>
                    <p className={classes.textoUno}>Número de contrato:</p>
                    <p className={classes.textoDos}>{contrato.nrContrato}</p>
                  </div>
                </div>
                <div className={classes.numContrato}>
                  <div className={classes.numContratoIcono}>
                    <IconBuildingFactory2
                      size={35}
                      color="black"
                      stroke={1.2}
                      style={{ marginRight:5 }}  
                    />
                  </div>
                  <div className={classes.numContratoTextos}>
                    <p className={classes.textoUno}>Operación:</p>
                    <p className={classes.textoDos}>
                      {contrato.operacion.descripcion}
                    </p>
                  </div>
                </div>

                <div className={classes.numContrato}>
                  <div className={classes.numContratoIcono}>
                    <IconCalendarTime
                      size={35}
                      color="black"
                      stroke={1.2}
                      style={{ marginRight:5 }}  
                    />
                  </div>
                  <div className={classes.numContratoTextos}>
                    <p className={classes.textoUno}>Período:</p>
                    <p className={classes.textoDos}>{contrato.mes}</p>
                  </div>
                </div>

                <div className={classes.numContrato}>
                  <div className={classes.numContratoIcono}>
                    <IconAlertCircle
                      size={35}
                      color="black"
                      stroke={1.2}
                      style={{ marginRight:5 }}  
                    />
                    
                  </div>
                  <div className={classes.numContratoTextos}>
                    <p className={classes.textoUno}>Estado:</p>
                    <p className={classes.textoDos}>
                      {contrato.estado.descripcion}
                    </p>
                  </div>
                </div>
              </Paper>
            </Paper>
          </section>

          {/*fin componente superior*/}
          <Grid container className={classes.containerbox}>
            <Grid item>
              <CardsIndividual
                titulo="Carga Individual"
                dataContrato={contrato}
                color="#F2F0E9"
                font="black"
              />
            </Grid>

            <Grid item>
              <CardsMasiva
                icono={<PublicIcon className={classes.iconos} />}
                titulo="Carga Masiva"
                color="#F2F0E9"
                font="black"
              />
            </Grid>
          </Grid>
        
        </div>
  );
}

export default CajaHoras;
